module.exports = __webpack_public_path__ + "img/logo.ee7c432.svg";